import React, { FC, useState } from 'react';
import { PageQueries, replaceQuery } from '@specs/navigation';
import dynamic from 'next/dynamic';
import { useRouter } from 'next/router';
import { Confetti } from '@components/UIKit/Confetti/Confetti';
const Modal = dynamic(import('@components/Modals/Modal').then(module => module.Modal), {
  ssr: false
});
const ToyPurchaseSuccess = dynamic(import('@components/Modals/Variants/ToyPurchaseSuccess/ToyPurchaseSuccess').then(module => module.ToyPurchaseSuccess), {
  ssr: false
});
interface Props {}
export const Modals: FC<Props> = ({}) => {
  const router = useRouter();
  const {
    purchasedToysQuery
  }: PageQueries = router.query;
  const [isOpenModal, setIsOpenModal] = useState(!!purchasedToysQuery);
  if (typeof purchasedToysQuery === 'undefined') return null;
  const onClose = () => {
    setIsOpenModal(false);
    replaceQuery(router, {
      purchasedToysQuery: undefined
    });
  };
  return <>
            <Modal isOpen={isOpenModal} onClose={onClose} data-sentry-element="Modal" data-sentry-source-file="Modals.tsx">
                <ToyPurchaseSuccess closeHandler={onClose} purchasedToysQuery={purchasedToysQuery} data-sentry-element="ToyPurchaseSuccess" data-sentry-source-file="Modals.tsx" />
            </Modal>
            {isOpenModal && <Confetti />}
        </>;
};